import React from 'react';
import { Route } from 'react-router-dom';

import UnderConstruction from 'shared/ui/UnderConstruction';
import Consultants from 'features/company/pages/employees/Consultants';
import EmployeeGroups from 'features/company/pages/employee-groups/EmployeeGroups';
import Employees from 'features/company/pages/employees/Employees';
import Stores from 'features/company/pages/stores/Stores';
import Projects from 'features/projects/pages/Projects';

export const companyRoutes = (
  <Route path='company'>
    <Route index element={<UnderConstruction />} />
    <Route path='projects'>
      <Route index element={<Projects />} />
      <Route path='new' element={<UnderConstruction />} />
      <Route path=':id' element={<UnderConstruction />} />
    </Route>
    <Route path='employees' element={<Employees />} />
    <Route path='consultants' element={<Consultants />} />
    <Route path='employee-groups' element={<EmployeeGroups key='activeEmployeeGroups' />} />
    <Route path='stores' element={<Stores key='activeStores' />} />
  </Route>
);

export const companyTitles = [
  { path: '/company/projects/new', title: 'Создание проекта' },
  { match: /^\/company\/projects\/[^/]+$/, title: 'Детали проекта' },
  { path: '/company/projects', title: 'Проекты' },
  { path: '/company/employees', title: 'Сотрудники' },
  { path: '/company/consultants', title: 'Консультанты компании' },
  { path: '/company/employee-groups', title: 'Группы сотрудников' },
  { path: '/company/stores', title: 'Магазины' },
  { path: '/company', title: 'Компания' },
];
